// Echeance deduite de X-Session-Remaining, recopiee dans localStorage pour
// synchroniser les onglets. null = inconnue, 0 = session fermee, sinon epoch en ms.

const STORAGE_KEY = 'vcode.session.expiresAt'
const HEADER = 'X-Session-Remaining'

type Listener = (expiresAt: number | null) => void

let expiresAt: number | null = readStored()
const listeners = new Set<Listener>()

function readStored(): number | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return raw === null ? null : Number(raw)
  } catch {
    return null
  }
}

function publish(value: number | null, persist: boolean) {
  expiresAt = value
  if (persist) {
    try {
      if (value === null) {
        window.localStorage.removeItem(STORAGE_KEY)
      } else {
        window.localStorage.setItem(STORAGE_KEY, String(value))
      }
    } catch {
      // Navigation privee : seule la synchronisation entre onglets est perdue.
    }
  }
  listeners.forEach((listener) => listener(value))
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      publish(event.newValue === null ? null : Number(event.newValue), false)
    }
  })
}

export function trackSession(response: Response): void {
  const header = response.headers.get(HEADER)
  if (header === null) {
    return
  }

  const seconds = Number(header)
  if (Number.isFinite(seconds)) {
    publish(seconds <= 0 ? 0 : Date.now() + seconds * 1000, true)
  }
}

export function getSessionExpiry(): number | null {
  return expiresAt
}

export function subscribeSessionExpiry(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
